import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { FALL_FRAMES } from "./constants";

// 落下アニメ：前進から/ジャンプから の 2 系統。アニメ完了後、呼び出し側で start 位置にリセットする。
// fwd: world 座標系の進行方向（dx, dz）。
// opts.stopAtY: 指定時は y がそこに到達したら停止（海ブロック上に止まる用）。
//               未指定時は y - 8 まで急降下（虚無への落下）。
// opts.jumpArc: true の時、弧を描いて空中に飛んでから降下（ジャンプアクションから呼ぶ用）。
//               false/未指定時は水平移動 → 急降下（前進アクションから呼ぶ用）。
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performCharFall = (
  scene: Scene,
  node: AbstractMesh,
  fwd: { dx: number; dz: number },
  opts?: { stopAtY?: number; jumpArc?: boolean },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();
    const start = node.position.clone();
    const endY = opts?.stopAtY !== undefined ? opts.stopAtY : start.y - 8;
    const jumpArc = opts?.jumpArc === true;

    const totalFrames = jumpArc ? FALL_FRAMES + 3 : FALL_FRAMES;
    const anim = new Animation(
      "charFall",
      "position",
      totalFrames,
      Animation.ANIMATIONTYPE_VECTOR3,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );

    if (jumpArc) {
      // 弧 → 着地予定点 → 急降下/海上停止
      anim.setKeys([
        { frame: 0, value: start.clone() },
        {
          frame: 3,
          value: new Vector3(start.x + fwd.dx * 1.0, start.y + 0.6, start.z + fwd.dz * 1.0),
        },
        {
          frame: 5,
          value: new Vector3(start.x + fwd.dx * 1.5, start.y, start.z + fwd.dz * 1.5),
        },
        {
          frame: totalFrames,
          value: new Vector3(start.x + fwd.dx * 2.0, endY, start.z + fwd.dz * 2.0),
        },
      ]);
    } else {
      // 水平移動 → 急降下
      anim.setKeys([
        { frame: 0, value: start.clone() },
        {
          frame: 2,
          value: new Vector3(start.x + fwd.dx * 1.0, start.y, start.z + fwd.dz * 1.0),
        },
        {
          frame: totalFrames,
          value: new Vector3(start.x + fwd.dx * 1.5, endY, start.z + fwd.dz * 1.5),
        },
      ]);
    }

    const a = scene.beginDirectAnimation(node, [anim], 0, totalFrames, false, speedRatio);
    a.onAnimationEnd = () => resolve();
  });
